// The router JSON-parses search values, so a typed-in `?ideaId=12` arrives as a number, not a string.
export const recordNumberParam = (value: unknown): string | undefined =>
  typeof value === 'string' || typeof value === 'number' ? String(value) : undefined;
